import React from 'react';
import { Button, Label } from '@nooz-optics/nooz-components-lib';
import { returnCurrencyCharFromCode } from '../../../../utils/globals';
import { ILabel } from '../../../../utils/types/contentful';
import { Image } from '../../../UI/Media/Image/index';

export interface CartManualUpsellProductProps {
  handleLineItemAdd: any;
  upSellProductLabel?: any;
  label: ILabel;
  itemLabel?: any;
  product?: Record<string, any>;
}

export const CartManualUpsellProduct = ({
  handleLineItemAdd,
  product,
  label,
}: CartManualUpsellProductProps) => {
  const currency = returnCurrencyCharFromCode(
    product?.fields?.shopifyData?.variants[0].priceV2.currencyCode
  );

  const handleOnClick = () =>
    handleLineItemAdd(product?.fields?.shopifyData?.variants[0]);

  return product ? (
    <div className='mb-4'>
      <div className='pb-2'>
        <Label {...label} size='base' weight='light' />
      </div>
      <button
        type='button'
        className='flex w-full border justify-between items-center cursor-pointer rounded-md py-2 hover:bg-gray-100 transition duration-300 ease-in-out'
        onClick={handleOnClick}
      >
        <div className='px-3 flex items-center'>
          <div className='mr-2'>
            <Button
              icon={{ iconKey: 'MdAdd', size: 'xl' }}
              size='lg'
              type='outlined'
              color={{ classname: 'primary' }}
            />
          </div>
          <div>
            <Label {...product?.label} size='lg' transform='capitalize' />
            <div className='flex items-baseline'>
              <Label
                text={product?.fields?.shopifyData?.variants[0].priceV2.amount}
                size='lg'
              />
              <Label weight='light' size='base' text={currency} />
            </div>
          </div>
        </div>
        <div className='mr-2 h-14 w-14 rounded-full overflow-hidden'>
          <Image
            objectFit='cover'
            width='100%'
            height='100%'
            media={{
              description: product?.fields?.shopifyData?.variants?.[0]?.title,
              file: {
                url:
                  product?.fields?.shopifyData?.variants[0].image.originalSrc,
              },
            }}
          />
        </div>
      </button>
    </div>
  ) : null;
};
